import AdminLayout from '../../../../Layout/AdminLayout'

export default function Changelog() {
    return (
        <AdminLayout title="General Settings">
            <div className="flex flex-col flex-wrap w-full bg-white shadow-md p-8 md:p-16 mt-4 gap-8">
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.30 (06/03/2026)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Added drug of choice, zip code, and gender identity to all exports.
                        </li>
                        <li>Increased the number of participant records that can be exported at once from 15,000 to 30,000.</li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.29 (05/27/2026)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Added demographic information to all exports.
                        </li>
                        <li>We now automatically prefill email addresses when a new user goes to register.</li>
                        <li>Fixed issues with timezone on the Dashboard and Reports pages.</li>
                        <li>Added new Dashboard section for respite services.</li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.28 (03/10/2026)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Updated the alert styles after choosing a
                            participant to be more consistent. Old alerts now
                            show text asking the user to update the alert to the
                            new style.
                        </li>
                        <li>Added Respite Services</li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.27 (01/15/2026)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Alerts added during intake are now part of the new
                            system.
                        </li>
                        <li>
                            Expanded the list of alerts available during intake.
                        </li>
                        <li>
                            We now correctly display all errors when registering
                            a new user.
                        </li>
                        <li>
                            Improved handling on all forms ensures that a form
                            cannot be created if a user is not currently seeing
                            a participant.
                        </li>
                        <li>
                            Improved validation on DOB search to ensure it is
                            not possible to search for an invalid date.
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.26 (01/06/2026)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Added text to indicate that the old alert style is
                            no longer supported and should be updated.
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.25 (12/19/2025)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Alert exports now include added by, cleared by and
                            participant id, even if the user or participant have
                            been deleted.
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.24 (10/07/2025)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Added the ability to search by email in the user
                            settings page.
                        </li>
                        <li>
                            Added the ability to filter by role in the user
                            settings page.
                        </li>
                        <li>Added confirmation dialog when deleting a user.</li>
                        <li>
                            A message is now required when creating an alert.
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.23 (09/03/2025)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Removed Massage Therapy (Hand, Head Or Feet) option
                            from holistic services form.
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.22 (07/23/2025)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Resolved crash when modifying start and end times
                            for holistic services.
                        </li>
                        <li>
                            Resolved crash when trying to view participant using
                            the old alert style.
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.21 (06/05/2025)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            Resolved bug where exports did not include the
                            correct date range.
                        </li>
                        <li>Added the ability to audit alerts.</li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.2 (03/17/2025)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>
                            All exports now use the new system, which should be
                            faster and more reliable. Exports are now limited to
                            15k records.
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.1 (03/07/2025)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>resolved error when sending out emails</li>
                        <li>resolved 405 error when exporting</li>
                    </ul>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-xl font-bold">
                        Version 1.0.0 (03/03/2025)
                    </h2>
                    <ul className="list-disc list-inside">
                        <li>added changelog page</li>
                        <li>updated all back end packages and frameworks</li>
                        <li>
                            fixed bug that might cause 500 error when hiding a
                            participant
                        </li>
                        <li>new alerts system</li>
                    </ul>
                </div>
            </div>
        </AdminLayout>
    )
}
